// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BarRank_wrapper__APFEJ","content":"BarRank_content__3oysk"};